import React, { useEffect, useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { useSelector } from 'react-redux'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { submitLeave } from '../../api/leaveApi'
import Loader from '../../components/loader/Loader'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);


const RequestForm = ({tab}) => {
    const {user} = useSelector((state)=>state.user)
    const [startDate, setStartDate] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [endDate, setEndDate] = useState()
    const [numOfDays, setNumOfDays] = useState();
    const [formType, setFormType] = useState()
    const {
        register,
        handleSubmit,
        formState:{errors},
        control,
        reset
    } = useForm()

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
    };

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
        calculateDays()
    };

    const calculateDays = () => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        let count = 0;
    
        // Loop through each day between start and end dates
        for (let date = new Date(start); date <= end; date.setDate(date.getDate() + 1)) {
            // Check if the day is not Saturday (6) or Sunday (0)
            if (date.getDay() !== 6 && date.getDay() !== 0) {
                count++;
            }
        }
    
        setNumOfDays(count);
    };

    useEffect(()=>{
        setFormType(tab)
    },[tab])

    useEffect(()=>{
        calculateDays()
    },[endDate])


    const onsubmit = async (data) => {
        setIsLoading(true)
        if(!startDate || !endDate){
            MySwal.fire({
                icon: 'warning',
                title: 'Enter required field!',
                showConfirmButton: false,
                timer: 2000
            });
        }
        try{
            const newData = {startDate: startDate, endDate: endDate, days: numOfDays, ...data}
            const res = await submitLeave(user?.token, newData)
            if(res?.success){
                MySwal.fire({
                    icon: 'success',
                    text: res?.message,
                    showConfirmButton: false,
                    timer: 4000
                });
                reset()
                setStartDate(null)
                setEndDate(null)
                setNumOfDays(null)
            }else{
                MySwal.fire({
                    icon: 'error',
                    title: 'Ooops',
                    text: res?.message,
                    showConfirmButton: false,
                    timer: 5000
                });
            }
            setIsLoading(false)
        }catch(error){
            setIsLoading(false)
            console.log(error)
            MySwal.fire({
                icon: 'error',
                title: "There's an error processing your request, Try again",
                showConfirmButton: false,
                timer: 2000
            });
        }
    }

  return (
    <section className='request__form-container'>
        <h3 className="request__form-title">
            <span style={{
                color: formType === "Annual Leave" ? "#05ac88"
                : formType === "Casual Leave" ? "#f7981c"
                : "#1991eb"
            }}>{formType}</span> Request Form
        </h3>
        <span className="request__form-subtitle">
            Please fill out the form below to request annual leave.
            All fields are required.
        </span>
        {/* FORM */}
        <form className='request__form' onSubmit={handleSubmit(onsubmit)}>
            {/* NAME */}
            <div className="request__form-item">
                <label htmlFor="name" className="request__form-label">
                    Name:
                </label>
                <input type="text" name="name" 
                className='request__form-input'
                value={user?.firstName + ' ' + user?.lastName}
                disabled/>
            </div>
            <div className="request__form-item_div">
                {/* START DATE */}
                <div className="request__form-item">
                    <label htmlFor="startDate" className="request__form-label">
                        Start Date:
                    </label>
                    <input type="date" name="startDate" id="startDate"
                    onChange={handleStartDateChange} value={startDate}
                    className='request__form-input' required
                    />
                </div>
                {/* END DATE */}
                <div className="request__form-item">
                    <label htmlFor="endDate" className="request__form-label">
                        End Date:
                    </label>
                    <input type="date" name="endDate" id="endDate"
                    onChange={handleEndDateChange} value={endDate}
                    className='request__form-input' required
                    />
                </div>
            </div>
            <div className="request__form-item_div">
                <div className="request__form-item">
                    <label htmlFor="leaveType" className="request__form-label">
                        Leave Type:
                    </label>
                    {formType === 'Annual Leave' ? (
                        <>
                            {/* LEAVE TYPE */}
                            <input type="text" name="leaveType" 
                            className='request__form-input'
                            value={'Annual Leave'} readOnly
                            {...register('leaveType',{required: 'This field is required'})}/>
                            {errors.leaveType && <span className="request__form-error">
                                {errors.leaveType.message}
                            </span>}
                        </>
                    ) : formType === 'Casual Leave' ? (
                        <>
                            {/* LEAVE TYPE */}
                            <input type="text" name="leaveType" 
                            className='request__form-input'
                            value={'Casual Leave'} readOnly
                            {...register('leaveType',{required: 'This field is required'})}/>
                            {errors.leaveType && <span className="request__form-error">
                                {errors.leaveType.message}
                            </span>}
                        </>
                    ) : formType === 'Other Leave' ? (
                        <>
                            {/* OTHER LEAVE TYPE */}
                            <select name='leaveType' className="request__form-input"
                            {...register('leaveType',{required: 'This field is required'})}>
                                <option value="Emergency Leave">Emergency Leave</option>
                                <option value="Exam Leave">Exam Leave</option>
                                <option value="Maternity Leave">Maternity Leave</option>
                                <option value="Others">Others</option>
                            </select>
                            {errors.leaveType && <span className="request__form-error">
                                {errors.leaveType.message}
                            </span>}
                        </>
                    ) : (
                        <></>
                    )}
                </div>
                {/* NO OF DAYS */}
                <div className="request__form-item">
                    <label htmlFor="days" className="request__form-label">
                        No of Days:
                    </label>
                    <input type="number" name="days" 
                    value={numOfDays} onChange={(e)=>setNumOfDays(e.target.value)} 
                    readOnly
                    className='request__form-input'
                    />
                </div>
            </div>
            {/* REASONS TEXTFIELD */}
            <div className="request__form-item" style={{width: '100%'}}>
                <label htmlFor="reason" className="request__form-label">
                    Reason:
                </label>
                <Controller
                    name="reason"
                    control={control}
                    defaultValue=""
                    rules={{
                        required: 'This field is required',
                        minLength:{
                            value: 50,
                            message: 'Please provide at least 50 words for your reasons.'
                        }   
                    }}
                    render={({ field }) => (
                        <ReactQuill
                        style={{width: '100%'}}
                            name="reason"
                            theme="snow"
                            value={field.value}
                            onChange={(content) => field.onChange(content)}
                        />
                    )}
                />
                {errors.reason && <span className="request__form-error">
                    {errors.reason.message}
                </span>}
            </div>
            {/* SUBMIT BUTTON */}
            <div className="request__form-item">
                {
                    isLoading ? <Loader/> :
                    <button type='submit'
                    className="request__form-btn button">
                        Submit
                    </button>
                }
            </div>
        </form>
    </section>
  )
}

export default RequestForm